document.addEventListener('click', (event) => {
  if (!event.target || !event.target.closest) {
    return;
  }
  const element = event.target.closest('[data-ga-event-onclick]');
  if (element) {
    const category = element.getAttribute('data-ga-category');
    const action = element.getAttribute('data-ga-action');
    const label = element.getAttribute('data-ga-label');
    const value = element.getAttribute('data-ga-value');

    if (!category || !action) {
      console.error(
        `GA error: element with 'data-ga-event-onclick' 
        attribute should also have at least 'data-ga-category' 
        and 'data-ga-action' attributes`,
      );

      return;
    }

    const args = ['send', 'event', category, action, label, value].filter(
      (v) => v,
    );

    if (!window.ga) {
      console.warn('window.ga is not defined. Call args: ', args);
      return;
    }

    window.ga.apply(null, args);
  }
});
